module.exports = __webpack_public_path__ + "media/components/assets/icons/question_circle-dde0606b96698ff826174e0053f65d56.svg";